<template>
  <div>
    <v-app>
      <v-img src="" class="background-display">
      <v-container>
      <v-card width="400" class="mx-auto mt-5">
        <v-toolbar dark color="#00b2bb">
          <v-card-title>
            <span class="headline font-weight-thin">Cambiar Contraseña</span>
          </v-card-title>
        </v-toolbar>
        <v-progress-linear v-if="apiRequest"
        indeterminate
        color="teal" dark
        ></v-progress-linear>
        <v-card-text>
          <v-alert v-model="alert" border="left" close-text="Close Alert" dismissible dense outlined type="error">
            Ha ocurrido un error! vuelva a intentarlo
          </v-alert>
          <v-alert v-model="alertEmailNotFound" border="left" close-text="Close Alert" dismissible dense outlined type="error">
            Error! El correo no existe
          </v-alert>
          <v-form ref="form">
              <p>Ingrese nuevamente su correo</p>
              <EmailField
                v-model="email"
                :name="email"
                :schema="{
                  label: 'Correo',
                  icon: 'mdi-email'
                }"
                solo
              >
              </EmailField>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="mx-2">
          <v-btn color="normal" :to="'/'">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="#00b2bb" dark v-if="!alert" @click="validationRules">Enviar</v-btn>
        </v-card-actions>
        <p class="ma-5 text-center">Ya tiene una cuenta? <a href="/">Iniciar Sesion</a></p>
      </v-card>
      </v-container>
      </v-img>
    </v-app>
  </div>
</template>
<style>
.title-size {
  font-size: 1.25em;
}
.background-display {
  background-color: #f5f5f5 !important;
  width: auto;
  min-height: 100%;
}
</style>
<script>
/* import { Auth } from 'aws-amplify' */
import { Auth } from '@aws-amplify/auth'
import EmailField from '../../components/fields/email/Field.vue'
/* import { AmplifyEventBus } from 'aws-amplify-vue' */
// @ is an alias to /src
export default {
  name: 'ForgotPassword',
  components: {
    EmailField
  },
  data: () => ({
    showPassword: false,
    alert: false,
    alertEmailNotFound: false,
    email: '',
    apiRequest: false,
    singedIn: false
  }),
  methods: {
    async changePassword () {
      this.apiRequest = true
      try {
        await Auth.forgotPassword(this.email)
        this.apiRequest = false
        this.$router.push({ path: '/confirmforgotpassword' })
      } catch (error) {
        if (error.message === 'Username/client id combination not found.') {
          this.alertEmailNotFound = true
        } else {
          this.alert = true
        }
        console.log(error)
        this.apiRequest = false
      }
    },
    validationRules () {
      if (this.$refs.form.validate()) {
        this.changePassword()
      }
    }
  }
}
</script>
